import React, { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { CommonDropdownProps } from '../types/common.types';
import { sortOptionsByLabel } from '../utils/sortOptions';

const CommonDropdown: React.FC<CommonDropdownProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder = 'Select',
  disabled = false,
  fullWidth = true,
}) => {
  const labelId = `${label.replace(/\s+/g, '-').toLowerCase()}-label`;
  const sortedOptions = useMemo(() => sortOptionsByLabel(options), [options]);

  return (
    <FormControl fullWidth={fullWidth} size="small" disabled={disabled}>
      <InputLabel id={labelId} shrink>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value}
        onChange={onChange}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return <span style={{ color: '#5f6f68' }}>{placeholder}</span>;
          }

          const selectedOption = options.find((option) => option.value === selected);
          return selectedOption?.label ?? String(selected);
        }}
      >
        {sortedOptions.map((option) => (
          <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CommonDropdown;
